<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="ded" id="start"><a id="page_v"></a>For my children, Victoria and Gabriella,<br/>whose patience with their busy mother<br/>and curiosity about this project never abated,<br/>I happily dedicate this book to them both.<a id="page_vi"></a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?78bd975a